import { selectableListBehavior } from './selectableListBehavior';
import { basicListBehavior } from './basicListBehavior';
import { navigableListBehavior } from './navigableListBehavior';

/**
 * @description
 * Defines a behavior 'BasicListBehavior' or 'SelectableListBehavior' based on property 'selectable'.
 */
export var listBehavior = function listBehavior(props) {
  return props.selectable ? selectableListBehavior(props) : props.navigable ? navigableListBehavior(props) : basicListBehavior(props);
};
//# sourceMappingURL=listBehavior.js.map
